/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ProfileIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 34 34"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinejoin="round">
      <path d="M13.3333333,20 C13.3333333,20 11.3333333,19.3333333 11.3333333,16 C10.232,16 10.232,13.3333333 11.3333333,13.3333333 C11.3333333,12.8866667 9.33333333,8 12.6666667,8.66666667 C13.3333333,6 20.6666667,6 21.3333333,8.66666667 C21.796,10.5173333 20.6666667,13.0053333 20.6666667,13.3333333 C21.768,13.3333333 21.768,16 20.6666667,16 C20.6666667,19.3333333 18.6666667,20 18.6666667,20 L18.6666667,23.3333333 C21.9693333,24.572 25.24,25.596 26.9146667,26.7666667 C29.6453333,23.9986667 31.3333333,20.196 31.3333333,16 C31.3333333,7.53066667 24.4693333,0.666666667 16,0.666666667 C7.53066667,0.666666667 0.666666667,7.53066667 0.666666667,16 C0.666666667,20.204 2.36,24.012 5.1,26.7826667 C6.87333333,25.556 10.3693333,24.4546667 13.3333333,23.3333333 L13.3333333,20 Z" />
      <path d="M5.1,26.7826667 C7.88,29.592 11.736,31.3333333 16,31.3333333 C20.2706667,31.3333333 24.1333333,29.5853333 26.9146667,26.7666667" />
    </g>
  </svg>
);

export default ProfileIcon;
